import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../components/pages/home/Index.vue";
import About from "../components/pages/About.vue";
import Contact from "../components/pages/Contact.vue";
import PropertiesList from "../components/pages/properties/List.vue";
import PropertiesItem from "../components/pages/properties/Item.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/sobre",
    name: "Sobre",
    component: About,
  },
  {
    path: "/contato",
    name: "Contato",
    component: Contact,
  },
  {
    path: "/imoveis",
    name: "Imóveis",
    component: PropertiesList,
  },
  {
    path: "/imoveis/:item",
    name: "Imóvel",
    component: PropertiesItem,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
